import { actionTypes as coreActionTypes } from '../core';
import * as actionTypes from './actionTypes';

const initialState = {
    items: {},
    ids: [],
    pagination: {},
    admins: []
};

export default (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.GET_AUDIT_LOGS.SUCCESS: {
            const { items, ids, pagination } = action.payload;
            return {
                ...state,
                items,
                ids,
                pagination
            };
        }
        case actionTypes.GET_AUDIT_ADMINS.SUCCESS:
            return {
                ...state,
                admins: action.payload || []
            };
        case coreActionTypes.RESET:
            return initialState;
        default:
            return state;
    }
};
